import React from 'react';
import { trackEvent } from "../../modules/tracking";
import { AnalyticsEvents } from "../../modules/analyticsEvents";
export default function HelperTrigger({ helperId, className = 'helper__info', onClick, eventLabel = null }) { const handleClick = e => { e.preventDefault(); if (eventLabel) {
    trackEvent(AnalyticsEvents.help.clickedHelperText(eventLabel));
} if (onClick) {
    onClick(e);
}
else {
    const helper = helperId ? document.getElementById(helperId) : null;
    if (helper)
        helper.classList.toggle('helper--visible');
} }; return /*#__PURE__*/ React.createElement("a", { className: className, onClick: handleClick, tabIndex: 0 }, /*#__PURE__*/ React.createElement("span", { className: "sr-only" }, "More information")); }
